import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
import { listarOrdens  } from '../../services/apigateway.js';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import ProcessandoModal from '../../components/Processamento/processamento.js';

import Globais from '../../components/Globais/Globais';
import Tabela from '../../components/Table/tabela';
import Comandos from '../../components/Comandos/comandos';
import Paginate from '../../components/Paginate/paginate';
import Filtros from '../../components/Filtros/filtros.js'; 

import { getPeriodoAtualFormatado, formatarData } from './../../services/datautils.js'
import { formatDate } from 'date-fns';

export default function Ordens(){ 
  const { clienteId, ligaMenu } = useContext(AuthContext);
  const [ordens, setOrdens] = useState([]);
  const [ordemFiltrado, setOrdemFiltrado] = useState([]);
  const [ordemPaginado, setOrdemPaginado] = useState([]);

  const [dataInicial, setDataInicial] = useState("01/01/2023");
  const [dataFinal, setDataFinal] = useState("31/05/2024");

  const periodo = getPeriodoAtualFormatado();
  
  const [loading, setLoading] = useState(true);
  const [coluna, setColuna] = useState();
  const [ordem, setOrdem] = useState('asc');

  const [currentPage, setCurrentPage] = useState(0);
  const [qtdPaginas, setQtdPaginas] = useState(0);
  const [qtdLinhas, setQtdLinhas] = useState(Globais.qtd_linhas); 

  const elementos = [
    { coluna: 'cod_ordmanutencao', cabecalho: 'Código', alinhamento: 'tdtabelaleft' },
    { coluna: 'num_ordmanutencao', cabecalho: 'Número', alinhamento: 'tdtabelaleft' },
    { coluna: 'res_ordmanutencao', cabecalho: 'Responsável', alinhamento: 'tdtabelaleft' },
    { coluna: 'dat_horinicial', cabecalho: 'Data Inicial', alinhamento: 'tdtabelaleft' },
    { coluna: 'sit_ordmanutencao', cabecalho: 'Situação', alinhamento: 'tdtabela' }, 
    { coluna: 'ação', cabecalho: 'Ação', alinhamento: 'tdtabela' }
  ];

  const [filtros, setFiltros] = useState({
    inicio: periodo.dataInicio,
    fim: periodo.dataFim,
    numeroOM: ''
  });

  const aplicarFiltros = () => {
    const params = {
      ...filtros,
      inicio: filtros.inicio,
      fim: filtros.fim,
      numeroOM: filtros.numeroOM
    };

    loadOrdens();
  };

  const handleFilterChange = (key, value) => {
    const valueDate = formatarData(value, "aaaa-mm-dd HH:MM");
    setFiltros(prev => ({ ...prev, [key]: valueDate }));
  };

  useEffect(() => {
      loadOrdens();
      return() => {}
  }, [filtros.inicio, filtros.fim]);

  async function loadOrdens(){
    try {
      if (!clienteId) {
        setLoading(false);
        return (<></>);
      }

      const dataHoraInicial = filtros.inicio;
      const dataHoraFinal = filtros.fim;

      // // console.log("dataHoraInicial: ", dataHoraInicial);
      // // console.log("dataHoraFinal: ", dataHoraFinal);

      // // const response = await listarOrdens(clienteId, dataHoraInicial, dataHoraFinal, filtros.numeroOM);

      // // if (response.codigo === '000') {
      // //   setOrdens(response.corpo);

      // //   let dados = filterOrdens(response.corpo, '');
      // //   setOrdemFiltrado(dados);
    
      // //   let qtdpag = Math.ceil(dados.length / qtdLinhas)
      // //   setQtdPaginas(qtdpag);
    
      // //   let datas = paginarOrdens(dados, 0, qtdLinhas);
      // //   setOrdemPaginado(datas);
      // //   setLoading(false);
      // //   setQtdPaginas(qtdpag);
      // // }
      
      // const url = Globais.url_consulta
      // // console.log("url: ", url);

      // const tabela = "Tab_OrdManutencao";
      // const campos = "cod_ordmanutencao, num_ordmanutencao, COALESCE(res_ordmanutencao, '') AS res_ordmanutencao, DATE_FORMAT(dat_horinicial, '%d/%m/%Y %H:%i') AS dat_horinicial, sit_ordmanutencao";
      // let condicao = "cod_cliente = " + clienteId;
      // const orderBy = "dat_horinicial";    

      // // if (filtros.numeroOM) {
      // //   condicao += ` AND num_ordmanutencao like '${filtros.numeroOM}%' `
      // // }

      // if (dataHoraInicial && dataHoraFinal) {
      //   condicao += ` AND dat_horinicial between '${dataHoraInicial}' AND '${dataHoraFinal}' `
      // }

      // // console.log("condicao: ", condicao);

      // const {data} = await Axios.post(url, { tabela: tabela, campos: campos, condicao: condicao, orderBy: orderBy });

      // let result = JSON.parse(data.body);
      // setOrdens(result);
      // // console.log('result OM: ', result);
      // let dados = filterOrdens(result, '');
      // setOrdemFiltrado(dados);

      console.log("dataHoraInicial: ", dataHoraInicial);
      console.log("dataHoraFinal: ", dataHoraFinal);

      const response = await listarOrdens(clienteId, dataHoraInicial, dataHoraFinal);

      setOrdens(response);

      let dados = filterOrdens(response, '');
      setOrdemFiltrado(dados);
  
      let qtdpag = Math.ceil(dados.length / qtdLinhas)
      setQtdPaginas(qtdpag);
  
      let datas = paginarOrdens(dados, 0, qtdLinhas);
      setOrdemPaginado(datas);
      setLoading(false);
      setQtdPaginas(qtdpag);
  
    } catch(err) {
      console.log(err);
    }

    setLoading(false);
  }

  function filterOrdens(dados, texto) {
    let data = [];
    
    dados && dados.filter(item => {return item.num_ordmanutencao.toLowerCase().includes(texto)}).map(dado => {
      data.push(dado)
    });

    return data; 
  }  
 
  function paginarOrdens(dados, offSet, qtdLinhas) {
    const startIndex = offSet;
    const endIndex = offSet + Number(qtdLinhas);

    let data = dados;
    return data.slice(startIndex, endIndex)
  }

  function handleSearch(texto) {
    let dados = filterOrdens(ordens, texto);
    setOrdemFiltrado(dados);

    let qtdpag = Math.ceil(dados.length / qtdLinhas)
    setQtdPaginas(qtdpag); 

    let data = paginarOrdens(dados, 0, qtdLinhas)
    setOrdemPaginado(data);  
    setCurrentPage(0);
    setColuna();
  }

  function handlePageClick({ selected: selectedPage }) { 
    let posicao = (selectedPage) * qtdLinhas;
    setCurrentPage(selectedPage); 

    let data = paginarOrdens(ordemFiltrado, posicao, qtdLinhas);
    setOrdemPaginado(data); 
  } 

  function handleQtdLinhas(valor) {
    if (Number(valor) === 0) {
      valor = ordemFiltrado.length;
    }

    setQtdLinhas(valor);

    let qtdpag = Math.ceil(ordemFiltrado.length / valor)
    setQtdPaginas(qtdpag);

    let data = paginarOrdens(ordemFiltrado, 0, valor);
    setOrdemPaginado(data); 

    setCurrentPage(0); 
  } 
    
  function handleSort(coluna) {
    let order = ordem;

    if (order === 'asc') {
      order = 'desc';
    } else {
      order = 'asc';
    }

    setColuna(coluna);
    setOrdem(order);

    const dataCopy = [...ordemFiltrado];

    dataCopy.sort((dataA, dataB) => {
      if (order === 'desc') {
        return dataA[coluna] > dataB[coluna] ? 1 : -1

      } else {
        return dataB[coluna] > dataA[coluna] ? 1 : -1
      }
    }); 

    setOrdemFiltrado(dataCopy); 

    let data = paginarOrdens(dataCopy, 0, qtdLinhas);
    setOrdemPaginado(data); 
    setCurrentPage(0); 
  } 

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Ordem de Manuenção'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, buscando Ordens de Manutenção..." />
        </section>
      </main>
    </div>
    )
  }
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      
      <main>
        <Titulo 
          tela={'Cadastro de Ordem de Manutenção'} 
          destination='/ordens/inclusao/'
          permissao='ORDEM_INCLUIR'
        />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <div>  
            <div className="min-h-screen bg-gray-100 p-6 flex flex items-center gap-4 p-1">
              <Filtros filtros={filtros} onFilterChange={handleFilterChange} onApply={aplicarFiltros} />
              <label>Número: </label>
              <div className="single-input">
                <input 
                  type="text" 
                  id='numeroOM' 
                  name='numeroOM' 
                  placeholder='Digite o número da OM' 
                  className='p-2 border border-gray-300 rounded-md' 
                  autoComplete='numero' 
                  onChange={e => handleSearch(e.target.value)}
                />
              </div>
            </div>
            <Tabela
              entidade='Ordens' 
              dados={ordemPaginado}
              elementos={elementos}
              handleSort={handleSort}
              sortedId={coluna}
              ordem={ordem}
              urlBase='/ordens'
            />
 
            {qtdPaginas > 1 ? (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {ordemFiltrado.length} 
                />
                
                <Paginate
                  qtdPaginas={qtdPaginas}
                  handlePageClick={handlePageClick}
                  currentPage={currentPage}
                />

              </div>
            ) : (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {ordemFiltrado.length} 
                />
              </div>
            )}
          </div>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
    );
  }
  